import React__default from 'react';
import styled from 'styled-components';
import { N as NumericOptionWrapper } from './NumericOption-BEP7gL-p.js';
import { E as EmojiLabel, b as borderRadius } from './Label/EmojiLabel-FSCYBxuU.js';

const EmojiOptionWrapper = /*#__PURE__*/styled(NumericOptionWrapper).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1bzqswr-0"
})(["flex-grow:0;", ""], borderRadius);
function EmojiOption(optionProps) {
  return /*#__PURE__*/React__default.createElement(EmojiOptionWrapper, optionProps, props => /*#__PURE__*/React__default.createElement(EmojiLabel, props));
}

export { EmojiOption as E };
//# sourceMappingURL=EmojiOption-Bed0m1rL.js.map
